import PropTypes from 'prop-types';
import { memo } from 'react';
import { useLocation } from 'react-router';

import { FiltersContainer, ToggleFilterStyled } from './TrlFilters.styles';

export const TrlFilters = memo(
  ({ selectedFilter, filters, handleChangeFilter, hasCustomStyles }) => {
    const { pathname } = useLocation();

    return (
      <FiltersContainer
        value={selectedFilter}
        exclusive
        onChange={handleChangeFilter}
        hasCustomStyles={hasCustomStyles}
        hasDisplayBlock={pathname === '/Dashboard'}
      >
        {filters.map((filter) => (
          <ToggleFilterStyled
            key={filter.value}
            id={filter.value}
            value={filter.value}
            hasCustomStyles={hasCustomStyles}
            disabled={filter.value === selectedFilter}
          >
            {filter.label}
          </ToggleFilterStyled>
        ))}
      </FiltersContainer>
    );
  },
);

TrlFilters.displayName = 'TrlFilters';

TrlFilters.propTypes = {
  selectedFilter: PropTypes.string.isRequired,
  filters: PropTypes.array.isRequired,
  handleChangeFilter: PropTypes.func.isRequired,
  hasCustomStyles: PropTypes.bool,
};
